import CircularLoader from "app/components/CircularLoader";
import { CloseIcon, DeleteIcon } from "app/components/Icons";
import ProfileAvatar from "app/components/ProfileAvatar";
import { IAvatar } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";
import clsx from "clsx";
import React, { ComponentProps, FC } from "react";

export interface UserAvatarProps {
  fullName: string;
  avatar: IAvatar;
  containerClassName?: string;
  nameClassName?: string;
  avatarProps?: ComponentProps<typeof ProfileAvatar>;
  onDelete?: () => void;
  onClose?: () => void;
  showDeleteIcon?: boolean;
  showCloseIcon?: boolean;
  deleteLoading?: boolean;
}

const UserAvatar: FC<UserAvatarProps> = ({
  fullName,
  avatar,
  avatarProps,
  nameClassName,
  containerClassName,
  onDelete,
  onClose,
  showDeleteIcon = false,
  showCloseIcon = false,
  deleteLoading = false,
}) => {
  return (
    <div
      className={clsx(
        "flex items-center gap-1.5 px-[18px] py-[15px] bg-gray-400 border border-gray-100 rounded-t justify-between",
        containerClassName,
      )}
    >
      <div className="flex items-center gap-1.5">
        <ProfileAvatar
          avatar={avatar}
          name={fullName}
          circleClassName={clsx(avatarProps?.circleClassName, "!size-5")}
          {...avatarProps}
        />
        <p
          className={clsx(
            "text-sm font-normal text-black leading-none truncate",
            nameClassName,
          )}
        >
          {fullName}
        </p>
      </div>

      <div className="flex items-center gap-1.5">
        {showDeleteIcon ? (
          <div className="size-6 flex items-center justify-center">
            {deleteLoading ? (
              <CircularLoader size="sm" />
            ) : (
              <DeleteIcon
                size={24}
                color="#EB5757"
                onClick={onDelete}
                className="cursor-pointer"
              />
            )}
          </div>
        ) : null}
        {showCloseIcon ? (
          <CloseIcon
            size={"24"}
            color="#79808A"
            onClick={onClose}
            className="cursor-pointer"
          />
        ) : null}
      </div>
    </div>
  );
};

export default UserAvatar;
